/* eslint-disable @typescript-eslint/naming-convention */
import { PREVIEW_PATH } from '@pai/commons'

export enum RoutePath {
  PREVIEW = PREVIEW_PATH,
  PREVIEW__LIVE = 'live',
  PREVIEW__DRAFT = 'draft',

  __SERVER_ERROR = 'server-error',
  __NOT_FOUND = 'not-found',

  /** be aware: pages path part is only used for previews, not for live site routing; then it is the default */
  PAGES = 'pages',

  PROJECTS = 'projects',
  PUBLICATIONS = 'publications',
}
